import { createRequest } from "helpers/tools";

export const sendLeadsquaredData = async (data) => {
    return await createRequest({
        suffix: "lsqrd",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const leadsquaredMapping = async (data, id) => {
    return await createRequest({
        suffix: `lsqrd/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getLeadsquaredMapping = async (id) => {
    return await createRequest({
        suffix: `lsqrd/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getLeadsquaredTest = async (id) => {
    return await createRequest({
        suffix: `lsqrd/${id}/preview`,
        method: "get",
        handleError: false,
    });
};
